import React from "react";

const PRODUCTS = [
  "RFQ™",
  "CommodityBid™",
  "FreightIQ™",
  "Inspection™",
  "Live Shipment Tracking™",
];

const COMPANY = ["About", "Manufacturers", "Security", "Contact"];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-white border-t border-black/[0.06]"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-10">
          <div className="col-span-2 sm:col-span-3 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <div>
                <div className="font-display font-bold text-[15px] tracking-tight">
                  DeMaxtore
                </div>
                <div className="font-mono text-[10px] tracking-[0.22em] text-black/45">
                  WORKSPACE PLATFORM
                </div>
              </div>
            </div>
            <p className="mt-5 text-[13.5px] leading-relaxed text-black/55 max-w-xs">
              The professional Workspace for global importers sourcing from
              verified Turkish manufacturers.
            </p>
          </div>

          <div>
            <div className="font-mono text-[10.5px] tracking-[0.2em] text-black/45">
              WORKSPACE PRODUCTS
            </div>
            <ul className="mt-4 space-y-2">
              {PRODUCTS.map((p) => (
                <li key={p}>
                  <a href="#" className="text-[13.5px] text-black/75 hover:text-black">
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[10.5px] tracking-[0.2em] text-black/45">
              COMPANY
            </div>
            <ul className="mt-4 space-y-2">
              {COMPANY.map((p) => (
                <li key={p}>
                  <a href="#" className="text-[13.5px] text-black/75 hover:text-black">
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[10.5px] tracking-[0.2em] text-black/45">
              REGION
            </div>
            <div className="mt-4 rounded-xl border border-black/[0.06] bg-[#FAFAFB] p-3.5">
              <div className="font-display text-[14px] font-semibold">
                Turkey ↔ Global
              </div>
              <div className="mt-1 text-[12.5px] text-black/55">
                Headquarters · Izmir / Istanbul
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-black/[0.06] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[11px] tracking-[0.18em] text-black/45">
            © {new Date().getFullYear()} DEMAXTORE · ALL RIGHTS RESERVED
          </p>
          <div className="flex items-center gap-4 text-[12px] text-black/55">
            <a href="#" className="hover:text-black">Privacy</a>
            <a href="#" className="hover:text-black">Terms</a>
            <a href="#" className="hover:text-black">Status</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
